"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "budoia": {
    "95bf3c68": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "skipSearch": false
    }],
    "dardago": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64423849": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd962806": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "skipSearch": false
    }],
    "val-de-croda": [{
      "hkey": "6ce6ad87",
      "slug": "budoia",
      "name": "Budoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;